import { createFileRoute } from "@tanstack/react-router";
import RoHelp from "@/pages/help/RoHelp";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/help/")({
  head: () => routeHead("/help/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <RoHelp />
  );
}
